// extracted by mini-css-extract-plugin
export default {"circle_button":"CountSetter_circle_button__tlF7i","shimmer":"CountSetter_shimmer__56dne"};